export default "__VITE_ASSET__K2qR24f9__"